/*
 * @Author: wuchenge
 * @Date:   2022-03-25 16:10:44
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-03-25 17:43:46
 */
import qs from "qs";

const apiUrl = process.env.REACT_APP_API_URL;

export const http = async (
  endpoint,
  data = {},
  token,
  headers,
  ...customConfig
) => {
  const config = {
    method: "GET",
    headers: {
      "Content-type": data ? "application/json" : "",
    },
    ...customConfig,
  };
  if (config.method.toUpperCase() === "GET") {
    endpoint += `?${qs.stringify(data)}`;
  } else {
    config.body = JSON.stringify(data || {});
  }

  // axios 和 fetch 的表现不一样， axios可以直接在返回状态不为2XX的时候抛出异常
  return window.fetch(`${apiUrl}${endpoint}`, config).then(async (response) => {
    const data = await response.json();
    if (response.ok) {
      if (data.error_code === 0) {
        return data.data;
      }
      return Promise.reject(data);
    }
    return Promise.reject(data);
  });
};
